



















































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Service from "@/services/KepatuhanVisiteDpjpService";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class KepatuhanVisiteRanapTab extends Vue {
  @Prop() register!: number;
  @Prop() rm!: number;
  @Prop({ default: false }) isActive!: boolean;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  loading = false;
  todaySessions: any[] = [];
  loaded = false;

  @Watch("isActive")
  onActiveChange(val: boolean) {
    if (val && !this.loaded) {
      this.loadTodaySessions();
    }
  }

  mounted() {
    if (this.isActive) {
      this.loadTodaySessions();
    }
  }

  async loadTodaySessions() {
    this.loading = true;
    try {
      const today = localISODate();
      const res = await Service.getSessions({ tanggal: today });
      const data = res.data;
      this.todaySessions = data.data || [];
      this.loaded = true;
    } catch {
      this.todaySessions = [];
    }
    this.loading = false;
  }

  openSession(sess: any) {
    this.$router.push({
      name: "kepatuhan-visite-dpjp",
      query: { session_id: sess.id }
    });
  }

  statusColor(status: string): string {
    const map: any = {
      draft: "grey",
      submitted: "blue",
      verified: "orange",
      approved: "green"
    };
    return map[status] || "grey";
  }
}
